import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import { ReactComponent as WarningICon } from '../../../../../../../assets/icons/warningIcon.svg';

export const WarningContent = () => {
  return (
    <div className={classNames('flex w-full p-2', styles.warning)}>
      <WarningICon />
      <div className="flex flex-col">
        <span className="font-semibold pb-1">Having trouble?</span>
        If the invitation link or QR code do not work, the patient can use their phone number to
        sign in.
      </div>
    </div>
  );
};
